// 定制了项目默认的多语言文案
import loadLocale from '@/locales/loadLocale'
import { createWithPageLocaleProvider } from 'core/components/Locale'
export * from 'core/components/Locale'

const withPageLocaleProvider = createWithPageLocaleProvider(loadLocale)
export default withPageLocaleProvider
